module.exports = __webpack_public_path__ + "img/productblank.8e652f74.png";